const shortAddress = (address) => {
  const addArray = address.split(/,[\s]*/ig).splice(-2);
  return addArray.join(', ');
};

export default shortAddress;
